import { attributeSelector, useVisibleElement } from "./useVisibleElement";

/**
 * O elemento do item de menu (`data-nav-key`) que ancora o cartão, ou `null` enquanto ele não
 * está na tela.
 *
 * A posição do cartão em si (inclusive quando o item se move ou muda de tamanho, SPOT-12) é
 * trabalho do Popper do Radix, que observa o tamanho e a posição desse elemento.
 *
 * @param {string|null} navKey chave de `NAV_ITEMS`; `null` desliga a busca
 */
export function useAnchorElement(navKey) {
  return useVisibleElement(navKey ? attributeSelector("data-nav-key", navKey) : null);
}
